// extracted by mini-css-extract-plugin
module.exports = {"container":"YourDreamCTA_container__cJ_V3","ctaContainer":"YourDreamCTA_ctaContainer__ngz3A","sliderContainer":"YourDreamCTA_sliderContainer__JtJ02"};